<template>
  <div
    class="autocomplete children-checklist cases-checklist"
    v-click-outside-children="onOutsideClick"
  >
    <!-- Input with validation-->
    <div
      v-if="validateProp"
      class="input-wrapper input-field"
      :class="{'error-input' : (errors.has(name) && validateField)}"
    >
      <input
        type="text"
        :placeholder="placeholder"
        class="input"
        :class="name"
        v-model="search"
        @click="onClick"
        @keydown.down="onArrowDown"
        @keydown.up="onArrowUp"
        @keydown.enter="onEnter"
        @focus.self="clearInputErrors"
        @blur="clearOthers"
        @keydown.tab="onTabClick"
        :name="name"
        v-validate="childrenValidationRule"
        readonly="readonly"
        autocomplete="off" />
      <span class="icon-wrapper" :class="name" @click="onClickArrow" >
        <img class="icon" :class="name" src='@/assets/images/arrow_down.png' />
      </span>
      <img
        src="@/assets/images/validation_ico.png"
        alt=""
        class="icon error-icon"
        :class="name"
      >
      <div
        v-show="(errors.has(name))"
        class="error-tooltip"
        :class="{'hide-tooltip' : bluredProp !== name}"
      >
        <div class="text">
          {{ errors.first(name) }}
        </div>
      </div>
    </div>
    <!-- Input with no validation-->
    <div
      v-if="!validateProp"
      class="input-wrapper input-field"
    >
      <input
        type="text"
        :placeholder="placeholder"
        class="input"
        :class="name"
        v-model="search"
        @click="onClick"
        @keydown.down="onArrowDown"
        @keydown.up="onArrowUp"
        @keydown.enter="onEnter"
        @keydown.tab="onTabClick"
        :name="name"
        readonly="readonly"
        autocomplete="off" />
      <span class="icon-wrapper" :class="name" @click="onClickArrow" >
        <img class="icon" :class="name" src='@/assets/images/arrow_down.png' />
      </span>
    </div>
    <ul
      v-show="isOpen"
      class="autocomplete-results"
      :class="name"
      ref="scrollContainer"
    >
      <li
        v-for="(result, indexResults) in results"
        :key="`childChecklist-${indexResults}`"
        class="autocomplete-result"
        :class="{ 'is-active': indexResults === arrowCounter, 'italics': result === 'No entry found' }"
        ref="options"
      >
        <label
          v-if="result.name != null"
          class="checkbox-wrapper"
          :class="name"
        >
          {{ result.name }}
          <input
            type="checkbox"
            class="checkbox-input"
            :class="name"
            v-model="result.clicked"
            @click="setResult(result)"
          >
          <span class="checkmark" :class="name" />
        </label>
        <span
          v-if="result.name == null"
          @click="setResult(result)"
        >
          {{ result }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside'

export default {
  name: "childrenChecklist",
  inject: ['$validator'],
  directives: {
    clickOutsideChildren: vClickOutside.directive
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    placeholder: {
      type: String,
      required: false,
      default: () => ""
    },
    option: {
      type: Array,
      required: false,
      default: () => []
    },
    name: {
      type: String,
      required: false,
      default: () => ""
    },
    bluredProp: {
      type: String,
      required: false,
      default: () => ''
    },
    validateProp: {
      type: Boolean,
      required: false,
      default: () => true
    },
    additionalValidationRule: {
      type: Boolean,
      required: false,
      default: () => true
    },
  },
  data() {
    return {
      newChildrenForInput: [],
      search: "",
      results: [],
      isOpen: false,
      isLoading: false,
      arrowCounter: -1,
      validateField: false
    };
  },
  computed: {
    childrenValidationRule() {
      return this.additionalValidationRule ? 'required' : 'min:1|required';
    },
  },
  mounted() {
    this.$validator.resume();
    if (this.option.length !== 0) {
      let childrenString = '';
      this.option.forEach(element => {
        childrenString = `${childrenString}${element.name}, `;
        this.items.forEach(item => {
          if (element.childGuid === item.childGuid) {
            item.clicked = element.clicked;
            this.newChildrenForInput.push(item);
          }
        })
      });

      // If input value ends with ", " remove it from the string
      childrenString = childrenString.substring(0, childrenString.length - 2);

      this.search = childrenString
    }
    //
    // document.addEventListener("click", this.handleClickOutside);
    //
    // if (this.validateProp) {
    //   document.addEventListener("click", this.onOutsideClick);
    // }
  },
  updated(){
    if (this.option.length !== 0) {
      this.option.forEach(element => {
        this.items.forEach(item => {
          //if this is a list of children
          if(element.childGuid !== undefined && item.childGuid!== undefined){
            if (element.childGuid === item.childGuid) {
              item.clicked = element.clicked;
            }
          }
          //if this is a list of events
          else{
            if (element.value === item.value) {
              item.clicked = element.clicked;
            }
          }
        })
      });
    }
  },
  destroyed() {
  //   document.removeEventListener("click", this.handleClickOutside);
  //   document.removeEventListener("click", this.onOutsideClick);
    this.$validator.pause();
  },
  methods: {
    onClick(e) {
      this.setValidateField();
      this.isOpen = true;
      this.results = [];
      this.results = this.items;
      this.setNoEntryFound();
      this.$emit("clearInputErrors", e);
    },
    onClickArrow() {
      this.setValidateField();
      this.isOpen = !this.isOpen;
      this.results = [];
      this.results = this.items;
      this.setNoEntryFound()
    },
    onChange() {
      this.optionChanged()
    },
    setNoEntryFound() {
      if (this.results.length === 0) {
        this.results.push(this.$lang.messages.tp_noEntryFound)
      }
    },
    /**
     *
     * @description Inject or remove the children from the input field
     * @param {Object} result
     * @return {String}
     */
    setResult(result) {
      // Track the index of currently selected element in dropdown
      let indexElem;
      // Reset status clicked to false to have default state
      result.clicked = !result.clicked;
      // Remove any errors associate with Children input
      this.$validator.errors.remove(this.name);

      // Find the index of currently clicked element in dropdown
      this.newChildrenForInput.forEach((elem, i) => {
        if(elem.childGuid && result.childGuid){
          if (elem.childGuid === result.childGuid) {
            indexElem = i
          }
        }
        else{
          if(elem.value === result.value){
            indexElem = i;
          }
        }
      });

      // On currently clicked element - add it to the array
      if (result.clicked) {
        this.newChildrenForInput.push(result)
      }
      // When we click on the same element, delete it from the array
      else {
        this.newChildrenForInput.splice(indexElem,1)
      }

      // Print the value to the input field when we have ONLY 1 element
      if (this.newChildrenForInput.length === 1) {
        this.search = this.newChildrenForInput[0].name
      }
      // Print the value to the input field when we have MORE than 1 element
      else if (this.newChildrenForInput.length > 1) {
        // Reset the input field to default
        this.search = '';
        // Recalculate the input field
        this.newChildrenForInput.forEach(child => {
          this.search = `${this.search}${child.name}, `;
        });
        // Remove the trailing comma at the end of the string
        this.search = this.search.substring(0, this.search.length - 2);
      }
      // Reset the input field to default
      else {
        this.search = ''
      }

      // Emit the input value to components
      this.optionChanged();
    },
    onArrowDown() {
      if (this.arrowCounter < this.results.length) {
        this.arrowCounter = this.arrowCounter + 1;
        this.fixScrolling();
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
        this.fixScrolling();
      }
    },
    fixScrolling() {
      if(this.$refs.options[this.arrowCounter]) {
        const liH = this.$refs.options[this.arrowCounter].clientHeight;
        this.$refs.scrollContainer.scrollTop = liH * this.arrowCounter;
      }
    },
    onTabClick(e) {
      if (!this.isOpen) {
        this.onClick(e);
      } else {
        this.isOpen = false;
        this.arrowCounter = -1;
        e.target.blur();
      }
    },
    onEnter() {
      if (this.results[this.arrowCounter]) {
        this.setResult(this.results[this.arrowCounter]);
      }
    },
    optionChanged() {
      this.$emit("optionChanged", this.newChildrenForInput);
      this.$validator.errors.remove(this.name);
    },
    clear() {
      this.search = ''
    },
    clearInputErrors(e) {
      this.onClick(e);
      this.$emit("clearInputErrors", e);
    },
    clearOthers(e) {
      // if(this.tabClicked)
        this.$emit("clearOthers", e);
    },
    onOutsideClick() {
      if (this.isOpen) {
        this.isOpen = false;
        this.arrowCounter = -1;
        if (this.validateProp) {
          if (this.search === '') {
            this.createError()
          } else {
            this.$validator.errors.remove(this.name)
          }
        }
      }
    },
    setValidateField() {
      this.validateField = true
    },
    createError() {
      if (!this.$validator.errors.has(this.name)) {
        this.$validator.errors.add({
          field: this.name,
          msg: `${this.$lang.messages.vee_the} ${this.name} ${this.$lang.messages.vee_requiredField}.`
        });
      } else {
        this.$validator.errors.remove(this.name)
      }
    }
  },
};
</script>
